import template from './conversation_trip.html';

export default {
  template: template,
  bindings: {
    conversation: '<',
  },
  controller: function($state, userModel) {
    'ngInject';

    try {
      this.location = userModel.item.location.name;
    } catch (e) {
      this.location = '';
    }

    this.openConversation = function () {
      $state.go('guides.trips');
    };
  },
};



// WEBPACK FOOTER //
// ./app/src/components/conversations_trips/conversation_trip.js